import { render, staticRenderFns } from "./produto_loja.vue?vue&type=template&id=933fd116&scoped=true&"
import script from "./produto_loja.vue?vue&type=script&lang=js&"
export * from "./produto_loja.vue?vue&type=script&lang=js&"
import style0 from "./produto_loja.vue?vue&type=style&index=0&id=933fd116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933fd116",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
